import * as Yup from 'yup';

export const QUESTIONS_PER_PAGE = 5;
export const ANSWERS_PER_PAGE_ON_DESKTOP = 4;
export const ANSWERS_PER_PAGE_ON_MOBILE = 5;
export const BEENVERIFIED_AI_USERNAME = 'BeenVerified AI';
export const BEENVERIFIED_AI_SOURCE = 'llm';

export const answerModalSchema = Yup.object({
  data: Yup.string()
    .required('Data is required')
    .min(5, 'Min 5 characters')
    .max(2000, 'Max 2000 characters'),
  name: Yup.string().nullable().max(20, 'Max 20 characters'),
});

export const COMMUNITY_BUZZ_INTRO_MODAL_SESSION_KEY =
  'community-buzz-intro-modal-shown';

export const COMMUNITY_BUZZ_GA4_EVENTS = {
  name: 'cta_click',
  type: 'view community buzz',
};

export const COMMUNITY_BUZZ_CTA_DESCRIPTION = {
  descriptionWithVehicleName: (vehicleName?: string) =>
    `Wondering how ${
      vehicleName ?? 'this car'
    } holds up in the real world? Community Buzz gathers authentic feedback from real owners and enthusiasts so you can shop smarter and more confidently. See the trends, spot the red flags, and learn what people really think, instantly.`,
  title: 'Get the Inside Scoop with Community Buzz',
  subtitle: 'Wondering how this car holds up in the real world?',
};

export const isAIContributor = (
  source?: string | null,
  username?: string | null
): boolean => {
  const normalizedSource = source?.toLowerCase();
  const normalizedUsername = username?.toLowerCase();
  const normalizedBumperSource = BEENVERIFIED_AI_SOURCE.toLowerCase();
  const normalizedBumperUsername = BEENVERIFIED_AI_USERNAME.toLowerCase();

  return (
    normalizedSource === normalizedBumperSource ||
    normalizedUsername === normalizedBumperSource ||
    normalizedUsername === normalizedBumperUsername
  );
};
